export default __webpack_public_path__ + "static/media/logo_orizzontale.37dc658e.svg";